import React, { useEffect, useId, useState } from "react";
import {
  AvatarPlaceholder,
  AvatarPlaceholders,
  Camera,
  Cancel,
  PlusGrey,
  ProfileImg,
} from "../../../../components/styled/AllImages";
import { Box, SpanStyled } from "../../../../components/styled/Elements";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const max = 10;

const MultipleImageUpload = ({
  onChange,
  onRemove,
  selectedImages,
  setDeletedImages,
  resetTrigger,
  max = 10,
  isLoading = false,
  disabled = false,
}) => {
  const [images, setImages] = useState([]); // Stores uploaded images
  const uniqueId = useId(); // Unique ID for input
  const { t } = useTranslation();

  // Handle file selection
  // const handleFileChange = (event) => {
  //   const files = Array.from(event.target.files);

  //   const totalSelected = images.length + files.length;
  //   console.log(totalSelected, images.length, files.length, max);

  //   let errorMessages = [];

  //   if (totalSelected > max) {
  //     const remainingSlots = max - totalSelected;

  //     if (remainingSlots < 0) {
  //       // toast.error(t("img_max_limit_reached", { max }));

  //       toast.error(
  //         t("img_partial_upload_limit", {
  //           accepted: max,
  //           selected: files.length,
  //           skipped: files.length - max,
  //           max,
  //         })
  //       );
  //     }
  //     if (max - totalSelected > 0) {
  //       errorMessages.push(
  //         t("img_limit_remaining", { count: max - totalSelected })
  //       );
  //     }
  //   }
  //   const remainingSlots = max - images.length;
  //   const selected = files.slice(0, remainingSlots);

  //   const newImages = selected.map((file) => ({
  //     id: URL.createObjectURL(file),
  //     file,
  //   }));

  //   const allImages = [...images, ...newImages];
  //   setImages(allImages);
  //   onChange(allImages.map((img) => img.file));

  //   if (errorMessages.length > 0) {
  //     errorMessages.forEach((error) => {
  //       toast.warning(error);
  //     });
  //   }
  //   // const files = event.target.files;
  //   // if (files.length > 0) {
  //   //   const newImages = [...images]; // Copy existing images
  //   //   for (let i = 0; i < files.length; i++) {
  //   //     if (newImages.length < max) {
  //   //       // Limit to 20 images
  //   //       newImages.push({
  //   //         id: URL.createObjectURL(files[i]), // Temporary URL for preview
  //   //         file: files[i], // Store file (optional, for upload)
  //   //       });
  //   //     }
  //   //   }
  //   //   onChange(newImages?.map((image) => image?.file));
  //   //   setImages(newImages);
  //   // }
  // };

  // Handle file selection with improved error messaging
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    const currentImageCount = images.length;
    const selectedFileCount = files.length;
    const remainingSlots = max - currentImageCount;

    // Calculate how many files can be accepted
    const acceptedCount = Math.min(selectedFileCount, remainingSlots);
    const skippedCount = selectedFileCount - acceptedCount;

    console.log({
      currentImageCount,
      selectedFileCount,
      remainingSlots,
      acceptedCount,
      skippedCount,
      max,
    });

    // Show appropriate toast messages
    if (remainingSlots < 0) {
      // No slots available
      toast.error(t("img_max_limit_reached", { max }));
    } else if (skippedCount > 0) {
      // Some files accepted, some skipped
      toast.warning(
        t("img_partial_upload_limit", {
          accepted: acceptedCount,
          selected: selectedFileCount,
          skipped: skippedCount,
          max,
        })
      );
    }

    // Only process files if there are remaining slots
    if (remainingSlots > 0) {
      const filesToProcess = files.slice(0, remainingSlots);

      const newImages = filesToProcess.map((file) => ({
        id: URL.createObjectURL(file),
        file,
      }));

      const allImages = [...images, ...newImages];
      setImages(allImages);
      onChange(newImages.map((img) => img.file));
    }

    // Clear the input value to allow re-selecting the same files
    event.target.value = "";
  };

  // Remove image by ID
  const removeImage = (id, imgId, index) => {
    const filteredImages = images.filter((img) => img.id !== id);
    setImages(filteredImages);
    if (onRemove) {
      onRemove(
        selectedImages
          ?.filter((img, i) => i != index)
          ?.map((image) => image?.image)
      );
    }
    if (imgId) {
      setDeletedImages((prevImg) => [...prevImg, imgId]);
    }
  };

  useEffect(() => {
    if (
      selectedImages &&
      Array.isArray(selectedImages) &&
      selectedImages?.length > 0
    ) {
      setImages(
        selectedImages.map((img) => ({
          imgId: img?.id,
          id: img?.image,
          file: img?.image,
        }))
      );
    }
  }, []);

  useEffect(() => {
    if (resetTrigger !== 0) setImages([]);
  }, [resetTrigger]);

  return (
    <ImageUploadContainer>
      {disabled && (
        <div className="overlayLoader">
          {isLoading && (
            <Box>
              <Box className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status" />
              </Box>
              <Box className="mt-2">
                <SpanStyled color="var(--text)">
                  {t("please_wait_img_upload")}
                </SpanStyled>
              </Box>
            </Box>
          )}
        </div>
      )}
      {/* Images Preview */}
      <Box className="imagePreviewGrid">
        {images.map((image, i) => (
          <Box key={image.id} className="imageThumbnail">
            <img src={image.id} alt="preview" className="previewImage" />
            <button
              className="deleteButton"
              onClick={() => {
                if (!disabled) removeImage(image.id, image?.imgId, i);
              }}
            >
              <Cancel />
            </button>
          </Box>
        ))}

        {/* Plus Button for Uploading More */}
        {images.length < max && (
          <Box
            className="addImageButton"
            onClick={() => {
              if (!disabled)
                document.getElementById(`imageInput-${uniqueId}`).click();
            }}
          >
            <PlusGrey />
          </Box>
        )}
      </Box>

      {/* Hidden File Input */}
      <input
        id={`imageInput-${uniqueId}`}
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        multiple // Allow multiple file selection
        style={{ display: "none" }}
        onChange={(event) => {
          if (!disabled) handleFileChange(event);
        }}
      />
    </ImageUploadContainer>
  );
};

export default MultipleImageUpload;

const ImageUploadContainer = styled.div`
  position: relative;
  .overlayLoader {
    position: absolute;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(1px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    border-radius: 10px;
  }

  .imageUploadContainer {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
  }

  .imagePreviewGrid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    /* justify-content: center; */
  }

  .imageThumbnail {
    position: relative;
    width: 113px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    background-color: var(--bg);
    border: 1px solid var(--border);
  }

  .previewImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .deleteButton {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(255, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 10px;
      height: 10px;
      [stroke] {
        stroke: var(--white);
      }
      [fill] {
        fill: var(--white);
      }
    }
  }

  .addImageButton {
    width: 113px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    background-color: var(--bg);
    border: 1px solid var(--border);
  }
`;
